import type { Store } from '../store.ts';

export function mountBanner(root: HTMLElement, store: Store): void {
  let timer = 0;
  store.subscribe((s, changed) => {
    if (!changed.has('banner')) return;
    clearTimeout(timer);
    if (!s.banner) { root.hidden = true; return; }
    root.textContent = s.banner;
    root.hidden = false;
    timer = window.setTimeout(() => store.set({ banner: null }), 8000);
  });
}
